import React from 'react';

import { withStyles } from '@mui/styles';
import { TableCell, TableRow } from '@mui/material';
import ArrowRight from '@mui/icons-material/KeyboardArrowRight';

import Node from '../../../common/Node';
import PredicateNew from '../../../common/PredicateNew';

const styles = {
  tableCell: {
    padding: '0px 2px 1px 0',
    borderBottom: 'none',
  },
  rstTitleArrow: {
    width: '21px',
    height: '21px',
    verticalAlign: 'middle',
    color: '#878787',
  },
};

function AbstractRestrictionItem({
    cid,
    nodes,
    classes,
    rstAbstr,
    rstrsSize,
    indexRstAbstr,
    getRestrictionByImplementedPid
  }) {

  function getFragmentWithOriginalPids(rid) {
    let rst = getRestrictionByImplementedPid(rid);
    if (rst) {
      return (
        <React.Fragment>
          <TableCell className={classes.tableCell}><ArrowRight className={classes.rstTitleArrow} /></TableCell>
          <TableCell className={classes.tableCell}>
            <Node
              nodeId={rst.sid} isLink size="sm"
              node={nodes[rst.sid]}
              nodes={nodes}
            />
          </TableCell>
          <TableCell className={classes.tableCell}>
            <PredicateNew
              key={indexRstAbstr}
              rst={rst}
              color={rstAbstr.color}
            />
          </TableCell>
        </React.Fragment>
      );
    }
    return null;
  }

  return (
    <React.Fragment>
      <TableRow key={indexRstAbstr}>
        <TableCell className={classes.tableCell}>
          <Node
            nodeId={cid} isLink size="sm"
            node={nodes[cid]}
            nodes={nodes}
          />
        </TableCell>
        <TableCell className={classes.tableCell}>
          <PredicateNew
            key={indexRstAbstr}
            rst={rstAbstr}
            color={rstAbstr.color}
          />
        </TableCell>
        {getFragmentWithOriginalPids(rstAbstr.id)}
      </TableRow>
      {indexRstAbstr === (rstrsSize - 1) ? (<TableRow style={{ height: '9px' }} />) : null}
    </React.Fragment>
  );
}

export default withStyles(styles)(AbstractRestrictionItem);
